import gql from 'graphql-tag';

export const createOrgStockAssets = gql`
  mutation createOrgStockAssets($organisationId: ID!, $assets: [StockAssetRecordInput]!) {
    createStockAssetRecords(input: {organisationId: $organisationId, assets: $assets}) {
      assetId
      externalId
      purchased
      source
      mediaType
      firstUseOutputId
      approvedByUserId
    }
  }
`;

const createStockAsset = (organisationId) => ({
  mutation: createOrgStockAssets,
  module: 'stock-assets',
  buildVariables: ({ assets }) => ({
    organisationId, assets
  })
});

export default createStockAsset;